import { useEffect } from "react"
import { I18nProvider } from "@lingui/react";
import { i18n } from "@lingui/core";
import { ThemeProvider, ScopedCssBaseline } from '@mui/material';
import NewsletterWidget from './components/NewsletterWidget';
import { Theme } from './theme/theme';
import { detectLanguage } from "./utilities/detectLanguage";
import { NewsletterSettingsContext, INewsletterSettings } from "./context/NewsletterSettingsContext";

interface Props {
  NewsletterSettings: INewsletterSettings
}

function App({NewsletterSettings}: Props) {
  useEffect(() => { detectLanguage() }, [])

  return (
    <NewsletterSettingsContext.Provider value={NewsletterSettings}>
      <ThemeProvider theme={Theme(NewsletterSettings)}>
        <ScopedCssBaseline>
          <I18nProvider i18n={i18n}>
            <NewsletterWidget/>
          </I18nProvider>
        </ScopedCssBaseline>
      </ThemeProvider>
    </NewsletterSettingsContext.Provider>
  )
}

export default App;